import { Component, OnInit, Input, ViewEncapsulation, HostListener, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StateService } from '@app/services/state/state.service';
import { ApiService } from '../services/api.service';
import { CreateAccountService } from '../services/createAccount.service';
import { isEmpty } from 'ramda';
import { ServiceConfigService } from '@app/services/service-config.service';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from './user-profile.service';
import { IdleService } from '@app/services/idle/idle.service';
import { ChangeEmailService } from './change-email/change-email.service';
import { ChangePasswordService } from './change-password/change-password.service';
import { ChangeSecurityQuestionsService } from './change-security-questions/change-security-questions.service';
import { LinkCaseService } from './link-case/link-case.service';
import { CommunicationPreferencesService } from './communication-preferences/communication-preferences.service';
import { JoyrideService } from 'ngx-joyride';
import { ModalService } from '@app/services/modal/modal.service';
import { HeaderComponent } from '@app/components/header/header.component';
import { ProcessService } from '@app/services/process.service';
import { SigninService } from '../signin/signin.service';
import { AppealsService } from './my-appeals/appeals.service';
import { Subscription } from 'rxjs';
import { SubmissionStatusService } from '@app/services/submission-status.service';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from '@app/services/token/token.service';
import { GlobalTranslateService } from '@app/services/globalTranslate/globalTranslate.service';
import { from } from 'rxjs';
declare const $: any;
declare let gtag: Function;

@Component({
    selector: 'nh-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() routerLinkActive;

  userDetails: any;
  isManageAccountsActive = false;
  isMyLink = false;
  applicationNum;
  isAppNum = false;
  hoh = false;
  isFromPartnerPortal;
  renewalDisable: boolean = true;
  qfrDisable: boolean = true;
  hasIndiv: boolean;
  isMenuOpened: boolean = false;
  hoveredOnRenew: boolean;
  hoveredOnQFR: boolean;
  hoveredOnCommunicate: boolean = false;
  hoveredOnReport: boolean;
  hoveredOnAFB: boolean;
  updateEmailLinkActive = false;
  updateEmailFrom;
  changePasswordLinkActive = false;
  changePassword;
  updateSecurityQuestionsLinkActive = false;
  mySubmissions = false;
  healthPlanDetailsTitle=false;
  updateSecurityQuestions;
  successMessage;
  isManageAccountActive = false;
  isLinkYourCaseActive = false;
  caseLinkfrom;
  isBenefitDashboardActive = false;
  isCoverageDetailsActive = false;
  iscommunicationPrefActive = false;
  myDocumentsTitle = false;
  showLeftPanel = true;
  myLetters = false;
  autoRenewal = false;
  disableRenewal = true;
  showTutorialInMobileView = false;
  screenHeight: number;
  screenWidth: number;
  isMobileView = false;
  mobileWidth = 480;
  dashboardTutorialActive = false;
  showDashboardTutorialInMobileView = false;
  disableRmc = false;
  translatedLang;
  enableChangeReport = false;
  indivId;
  showHealthPlanDetails: boolean;
  hoveredOnHealthPlan: boolean;
  mcoMasterSwitch:boolean;
  appealsMasterSwitch:boolean;
  showMyAppeals:boolean;
  showQFR: boolean = false;
  appealContinuanceTitle=false;
  appealWithdrawalTitle=false;
  appealFactSubmissionTitle=false;
  appealDashboardTitle = false;
  myAppealsTitle = false;
  showAppeals:boolean;
  step4;
  mobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  showQFRLink: Subscription;
  showAppealsLink: Subscription;
  showHealthPlanLink: Subscription;
  readTCC = sessionStorage.getItem('ReadTCC') === 'true' ? true : false;
  viewTCC = sessionStorage.getItem('ViewTCC') === 'true' ? true : false; 
  afbLinkToggle : boolean = false;
  kbSwitch: boolean = false;
  isLoggedUserHoh: boolean = false;
  isReconDate: boolean = false;
  isCaseTerminated: boolean = false;
  dcsOrSSIMultipleCase: boolean = false;
  isCaseDenied: boolean = false;
  isEbmsUser = false;
  ebmsCodeEnable;
  submissionStatus:boolean = false;
  enableLtssLettersSwitch:boolean;
  submissionStatusSwitch: boolean = false;
  appealPetitionSubmissionTitle=false;
  enableRIDPFlow: boolean = false;
  budgetDetailsTitle:boolean = false;
  awsTranslateSwitch: boolean = false;
  currentGlobalLang: string = null;
  medicalAppealsSwitch: boolean = false;
  constructor(private apiservice: ApiService,
    private userProfileService: UserProfileService,
    public createAccount: CreateAccountService,
    private route: ActivatedRoute,
    private router: Router,
    private stateService: StateService,
    private serverConfig: ServiceConfigService,
    public translateService: TranslateService,
    private idleService: IdleService,
    public changeEmailService: ChangeEmailService,
    private changePasswordService: ChangePasswordService,
    private changeSecurityQuestionsService: ChangeSecurityQuestionsService,
    public linkCaseService: LinkCaseService,
    public communicationPreferencesSvc: CommunicationPreferencesService,
    public apiService: ApiService,
    public readonly joyrideService: JoyrideService,
    private modalService: ModalService,
    private headerComponent: HeaderComponent,
    public processService: ProcessService,
    public signInService: SigninService,
    public appealsService: AppealsService,
    public submissionStatusService: SubmissionStatusService,
    private token: TokenService,
    private globalTranslateService: GlobalTranslateService
  ) {
    this.getScreenSize();
  }

  @HostListener("window:resize")
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }
  @ViewChild('step1') private step1: ElementRef;
  @ViewChild('step2') private step2: ElementRef;
  @ViewChild('step3') private step3: ElementRef;


  ngOnInit(): void {
    this.currentGlobalLang = sessionStorage.getItem('globalTranslatedLan') && sessionStorage.getItem('globalTranslatedLan') !== 'undefined' ? sessionStorage.getItem('globalTranslatedLan') : null;
    this.ebmsCodeEnable = this.serverConfig.getServerConfig().ebmsCodeEnable;
    this.mcoMasterSwitch = this.serverConfig.getServerConfig().mcoMasterSwitch;
    this.appealsMasterSwitch = this.serverConfig.getServerConfig().appealsMasterSwitch;
    this.afbLinkToggle = this.serverConfig.getServerConfig().AFB_LINK_SWITCH;
    this.submissionStatusSwitch = this.serverConfig.getServerConfig().SUBMISSION_STATUS_SWITCH;
    this.enableRIDPFlow = this.serverConfig.getServerConfig().enableRIDPFlow;
    this.awsTranslateSwitch = this.serverConfig.getServerConfig().awsTranslateSwitch;
    this.medicalAppealsSwitch = this.serverConfig.getServerConfig()?.medicalAppealsSwitch;
    // Restore behavior subjects from sessionStorage if available after language switch page reload
    this.userProfileService.restoreBehaviorSubjectsFromSession();
    const hidePanel = sessionStorage.getItem('hidePanel');
    this.showLeftPanel = hidePanel === 'true' ? false : true;
    const indiv = sessionStorage.getItem('individualId');
    this.signInService.getIndivId.next(indiv);
    this.hasIndiv = indiv && indiv != 'null' && indiv != '0' ? true : false;
    this.applicationNum = sessionStorage.getItem('appNum');
    this.isAppNum = this.applicationNum === 'null' && this.applicationNum === '0' && this.applicationNum === 0 ? false : true;
    const indivId = sessionStorage.getItem('individualId');
    const userType = sessionStorage.getItem('userType');
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isFromPartnerPortal = userType === 'RP' && !isEmpty(indivId);
    this.readTCC = sessionStorage.getItem('ReadTCC') === 'true' ? true : false;
    this.viewTCC = sessionStorage.getItem('ViewTCC') === 'true' ? true : false;
    const hoh = JSON.parse(sessionStorage.getItem('hoh'));
    this.hoh = hoh == null ? this.isFromPartnerPortal : hoh == true ? true : false;
    this.enableLtssLettersSwitch=this.serverConfig.getServerConfig().enableLtssLettersSwitch;
    const userName = {
      'userName': JSON.parse(sessionStorage.getItem('currentUser')) ?.userId ?
        JSON.parse(sessionStorage.getItem('currentUser')).userId : sessionStorage.getItem('userName')
    }

    this.userProfileService.reconDate.subscribe((bool) => {
      if(bool === true){
        this.isReconDate = bool;
      }
    })

    this.userProfileService.isCaseTerminated.subscribe((bool) => {
      if (bool === true) {
        this.isCaseTerminated = bool;
      }
    })

    this.userProfileService.isCaseDenied.subscribe((bool) => {
      if (bool === true) {
        this.isCaseDenied = bool;
      }
    })

    this.userProfileService.isHoh.subscribe((bool) => {
      if (bool === true) {
        this.isLoggedUserHoh = bool
      }
    })
    this.userProfileService.getKbData.subscribe((bool) => {
      if (bool === true) {
        this.kbSwitch = bool;
      }
    })

    this.userProfileService.dcsOrSSIMultipleCase.subscribe((bool) => {
      if (bool === true) {
        this.dcsOrSSIMultipleCase = bool;
      }
    })
    this.userProfileService.hideRenew$.subscribe((bool) => {
      this.renewalDisable = bool && this.hasIndiv && !this.readTCC;
      if (this.userStatus && this.renewalDisable) {
        sessionStorage.setItem('rmbLinkStatus', JSON.stringify(this.renewalDisable));
      } else {
        sessionStorage.removeItem('rmbLinkStatus');
      }
    });
    this.userProfileService.enableChangeReport.subscribe(res => {
      this.enableChangeReport = res;
    })
    this.userProfileService.disableChangeReport$.subscribe((value) => {
      this.disableRmc = !this.readTCC ? value : false
      if (this.userStatus && this.disableRmc) {
        sessionStorage.setItem('rmcLinkStatus', JSON.stringify(this.disableRmc));
      } else {
        sessionStorage.removeItem('rmcLinkStatus');
      }
    })
    this.route.queryParams.subscribe((res) => {
      if (!isEmpty(res)) {
        this.successMessage = res
      }
    })

    this.showQFRLink = this.userProfileService.showHideQFR.subscribe((bool) => {
      if(bool === true && !this.readTCC){
        this.showQFR = true;
      } 
    });

    this.showAppealsLink = this.userProfileService.showHideMyAppeals.subscribe((bool) => {
      if (bool === true) {
        this.showAppeals = true; //pendingAppeal
      } else {
        this.showAppeals = false;
      }
    });

    this.showHealthPlanLink = this.userProfileService.enableAppealOrHealthPlan.subscribe((bool) => {
    if (this.appealsMasterSwitch) {
      if (currentUser?.accountTypeCd === 'CL' && bool === true && !this.showAppeals) {
        if (sessionStorage.getItem('individualId') === 'null' || sessionStorage.getItem('individualId') === '0') {
          this.showMyAppeals = false;
        }
        else {
          this.showMyAppeals = true;
        }
      } else {
        this.showMyAppeals = false;
      }
    }
    if(this.mcoMasterSwitch){
      if (currentUser?.accountTypeCd === 'CL'  && bool === true) {
        if(sessionStorage.getItem('individualId') === 'null' || sessionStorage.getItem('individualId') === '0'){
          this.showHealthPlanDetails = false;
        }
        else{
          this.showHealthPlanDetails = true;
        }    
      }else{
        this.showHealthPlanDetails = false;   
      }
    }
  });

    const children = this.route.snapshot.children[0];
    if (children && children.url && children.url[0]) {
      const path = children.url[0].path;
      if (path === "update-security-questions" || path === "update-email") {
        this.isManageAccountsActive = true;
        this.isMyLink = true;
      }
      if (path === "update-email") {
        this.updateEmailLinkActive = true;
        this.updateEmailFrom = this.changeEmailService.updateEmailFrom;
      }
      if (path === "change-password") {
        this.changePasswordLinkActive = true;
        this.changePassword = this.changePasswordService.changePassword;
      }
      if (path === "update-security-questions") {
        this.updateSecurityQuestionsLinkActive = true;
        this.updateSecurityQuestions = this.changeSecurityQuestionsService.updateSecurityQuestions;
      }
      if (path === "manage-account") {
        this.isManageAccountActive = true;
        this.createAccount.manageAccountFormUpdateState = false;
      }
      if (path === "case-link") {
        this.isLinkYourCaseActive = true;
        this.caseLinkfrom = this.linkCaseService.caseLinkfrom;
        this.linkCaseService.isError = false;
      }
      if (path === "benefit-dashboard") {
        this.isBenefitDashboardActive = true;
      }
      if (path === "communication-preferences") {
        this.iscommunicationPrefActive = true;
      }
      if (path === "my-documents") {
        this.myDocumentsTitle = true;
      }
      if (path === 'letters') {
        this.myLetters = true;
      }
      if (path === 'auto-renewal') {
        this.autoRenewal = true;
      }

      if (path === "coverage-details") {
        this.isCoverageDetailsActive = true;
      }
      if (path === 'my-submissions') {
        this.mySubmissions = true;
      }
      if (path === 'healthplan-details') {
        this.healthPlanDetailsTitle = true;
      }
      if (path === 'appeal-continuance') {
        this.appealContinuanceTitle = true;
      }
      if (path === 'appeal-withdrawal') {
        this.appealWithdrawalTitle = true;
      }      
      if (path === 'appeal-fact-submission') {
        this.appealFactSubmissionTitle = true;
      }
      if (path === 'appeal-petition-submission') {
        this.appealPetitionSubmissionTitle = true;
      }
      if(path === 'my-appeals'){
        this.appealDashboardTitle = true; 
      }

      if(path === 'application-status'){
        this.submissionStatus = true;
      }

      if (path === 'budget-details') {
        this.budgetDetailsTitle = true;
      }

      if(path === 'appeals-dashboard'){
        this.myAppealsTitle = true;
      }
    };

    
    if (!sessionStorage.getItem('backOrRefresh')) {
      if(sessionStorage.getItem('userType') !== 'RP' || (sessionStorage.getItem('userDetails') && sessionStorage.getItem('userType') === 'RP')){
      this.route.queryParams.subscribe((res) => {
        if (res['tccToken']) {
          sessionStorage.setItem('TCAM', res['tccToken']);
        }
      })
      const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
      this.userDetails = sessionStorage.getItem('userType') !== 'RP' ? currentUser : userDetails;
      this.userProfileService.setEmailId(this.userDetails['emailId']? this.userDetails['emailId'] : this.userDetails['email']);
      const object =
      {
        "email": this.userDetails['emailId']? this.userDetails['emailId'] : this.userDetails['email'],
        "firstName": this.userDetails['firstName'],
        "lastName": this.userDetails['lastName'],
        "middleName": this.userDetails['middleName'],
        "emailId": this.userDetails['emailId']? this.userDetails['emailId'] : this.userDetails['email'],
      }

      this.createAccount.setUserObj(object);
      } else if(!sessionStorage.getItem('userDetails') && sessionStorage.getItem('userType') === 'RP') {

        this.route.queryParams.pipe((res) => {
          if (res['tccToken']) {
            sessionStorage.setItem('TCAM', res['tccToken']);
          }
          const contentHeader = new HttpHeaders({ 'pageId': 'TCMMA', 'sessionId' : this.token.getSessionId() })
          return this.apiservice.post('indi/users/manageMyAccount', userName, { headers: contentHeader })
        }).subscribe((res) => {
          this.userDetails = res;
          sessionStorage.setItem('userDetails', JSON.stringify(res))
          this.userProfileService.setEmailId(res['email']);
          this.createAccount.setUserObj(res);
        })
      }
  }
 
    const firstTimeUser = sessionStorage.getItem('firstTimeAccessSw');
    this.isMobileView = this.screenWidth <= this.mobileWidth;
    if (firstTimeUser && firstTimeUser === "Y" && this.isMobileView) {
      this.showTutorialInMobileView = true;
    }
    this.translatedLang = this.translateService.getDefaultLang();
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
    });
  }

  ngAfterViewInit(): void {
    this.userProfileService.sendStep1Info(this.step1);
    this.userProfileService.sendStep2Info(this.step2);
    this.userProfileService.sendStep3Info(this.step3);
    if (this.updateSecurityQuestionsLinkActive) {
      this.updateSecurityQuestions = this.changeSecurityQuestionsService?.updateSecurityQuestions;
    }
  }

  checkReportChangeEnabled() {
    if(this.enableChangeReport)
      return false;    
    else
      return !this.disableRmc;
  }
  
  applyNow() {
    gtag('event', 'start_afb', {
      'event_category': 'start_afb',
      'event_label': 'afb_started',
    });
    this.isEbmsUser = this.ebmsCodeEnable ? JSON.parse(sessionStorage.getItem("ebmsUser")) : false;
    if (!this.isEbmsUser){
    sessionStorage.setItem('appType', 'AFB');
    this.applicationNum = sessionStorage.getItem('appNum');
    this.isAppNum = this.applicationNum === null || this.applicationNum === 'null' || this.applicationNum === '0' || this.applicationNum === 0 ? false : true;
    if (this.isAppNum) {
      this.router.navigate(['/start', 'welcomeback'])
    } else {
      sessionStorage.setItem('isNewApp', 'true');
      this.stateService.continueApplication(true);
      this.router.navigateByUrl('/application/' + 'NEW');
    }
  } else {
    this.router.navigate(['/start', 'welcomeback'])
  }
  }

  backToPartnerPortal() {
    sessionStorage.removeItem('hidePanel');
    sessionStorage.removeItem('individualId');
    sessionStorage.removeItem('wpAppNum');
    sessionStorage.removeItem('indivIds');
    this.router.navigateByUrl('api/prov/atglance?entityId=' + this.apiService.getEntityId());
  }

  tccCall(): void {
    const userName = {
      'userId': JSON.parse(sessionStorage.getItem('currentUser')) ?.userId,
      'tcam': this.idleService.getCookie('TCAM')
    }
    this.userProfileService.getTccAppData('/accounts/getEncryptedDetails', userName).subscribe((res) => {
      window.location.href = `https://devr2-cp.teds.tn.gov/access?tccToken=${res['encryptionText']}`;
    })
  }

  menuClick(): void {
    this.isMenuOpened = !this.isMenuOpened;
  }

  updateEmail1() {
    this.changeEmailService.updateEmail();
  }

  isPasswordFormValid() {
    return this.changePasswordService.isFormValid();
  }

  updatePassword(): void {
    this.changePasswordService.updatePassword();
  }

  saveSecurityQuestion(): void {
    this.changeSecurityQuestionsService.saveSecurityQuestion();
  }

  disableQAM() {
    return !this.updateEmailLinkActive && !this.changePasswordLinkActive && !this.updateSecurityQuestionsLinkActive &&
      !this.successMessage ?.updatedEmail && !this.successMessage ?.updatedPassword && !this.successMessage ?.updatedSecurityQuestions;
  }

  onPrevious() {
    if(sessionStorage.getItem('MobileDocuUploadedScreen') === 'true') {
      sessionStorage.removeItem('MobileDocuUploadedScreen')
      this.router.navigate(['user-profile/my-documents', 'documents-we-need'])
    } else {
      this.router.navigateByUrl('user-profile/benefit-dashboard');
    }
  }

  validateUser() {
    const data = {
      showTutorial: "N",
    };
    this.userProfileService.postTutorial(data).subscribe();
  }

  openTutorial() {
    this.modalService
      .openCoverageTutorial()
      .subscribe(this.startTutorial.bind(this));
  }

  applyAccessibilityFocus(data: any) {

     setTimeout(() => {
            const previousHighlight = document.querySelector('#highlighted-step-section')
            const highlighted = document.querySelector(`[joyrideStep="${data.name}"]`) as HTMLElement;
            if(previousHighlight && previousHighlight !== highlighted) {
              previousHighlight.removeAttribute('tabindex');
              previousHighlight.removeAttribute('id');
            }
            const popup = document.querySelector('.joyride-step__holder') as HTMLElement;
            const popupText = popup.querySelector('joyride-step__body') as HTMLElement;
            const closeBtn = popup.querySelector('.joyride-step__close') as HTMLElement;
            const nextBtn = popup.querySelector('button.joyride-button') as HTMLElement;

            if (highlighted) {
              highlighted.setAttribute('tabindex', '0');
              highlighted.setAttribute('id', 'highlighted-step-section')
              highlighted.focus();
            }
            if(popup) {
              const tutorialTitle = this.translateService.instant('TUTORIAL_TITLE');
              popup.setAttribute('role', 'dialog');
              popup.setAttribute('aria-modal', 'true');
              popup.setAttribute('title', tutorialTitle || 'Tutorial');
              popup.setAttribute('tabindex', '0');
            }

              if (popupText) {
                popupText.setAttribute('id', 'tutorial-step-text');
                popup.setAttribute('aria-describedby', 'tutorial-step-text');
              }
               if (closeBtn) {
                closeBtn.setAttribute('tabindex', '0');
                closeBtn.setAttribute('role', 'button');
                closeBtn.setAttribute('aria-label', 'close');
              }

              const focusOrder: HTMLElement[] = [highlighted , popup, closeBtn, nextBtn].filter(Boolean)

              document.removeEventListener('keydown', (window as any).__joyrideTabTrap)

              let currentIndex = 0;
              const trapHandler = 
               (e: KeyboardEvent) => {
                if (e.key === 'Tab') {
                  e.preventDefault();
                  currentIndex = e.shiftKey ? (currentIndex - 1 + focusOrder.length) % focusOrder.length : (currentIndex + 1) % focusOrder.length;
                  focusOrder[currentIndex]?.focus();
                }
              };

              (window as any).__joyrideTabTrap = trapHandler;
              document.addEventListener('keydown', trapHandler)

              document.querySelector('main')?.setAttribute('inert', '');
            
          }, 300);
  }

  resetAccessibilityFocus() {
    const oldHighlight = document.querySelector('#highlighted-step-section');
          if(oldHighlight) {
            oldHighlight.removeAttribute('tabindex');
            oldHighlight.removeAttribute('id');
          }

          const main = document.querySelector('main');
          if(main) {
            main.removeAttribute('inert');
          }

          const popup = document.querySelector('.joyride-step__holder') as HTMLElement;
          if(popup) {
            popup.removeAttribute('aria-describedby');
            popup.removeAttribute('tabindex');
            
          }
          const popupText = popup?.querySelector('.joyride--step__body');
          popupText?.removeAttribute('id');

          (window.document.activeElement as HTMLElement)?.blur();
          document.getElementById('tutorial')?.focus();
          document.removeEventListener('keydown', (window as any).__joyrideTabTrap);
  }

  startTutorial() {
    const closeTutorial = sessionStorage.getItem('closeTutorial');
    if (closeTutorial !== "true") {
      this.userProfileService.step4Info.subscribe(data => {
        this.step4 = data;
      });
      
      let selectedLang = sessionStorage.getItem('globalTranslatedLan') && sessionStorage.getItem('globalTranslatedLan') !== 'undefined' ? sessionStorage.getItem('globalTranslatedLan') : null;
      
      if(selectedLang === 'es'){
        selectedLang = 'sp';
      }
      
      // Get translations using the same logic as globalTranslate pipe
      this.translateService.get(['TUTORIAL_FINISH', 'TUTORIAL_PREV', 'TUTORIAL_NEXT']).subscribe(translations => {
        
        // If AWS translate switch is false or using en/sp, use the translations directly
        if(!this.awsTranslateSwitch || !selectedLang || selectedLang === 'en' || selectedLang === 'sp' || selectedLang === 'es'){
          const customTexts = {
            done: translations['TUTORIAL_FINISH'],
            prev: translations['TUTORIAL_PREV'],
            next: translations['TUTORIAL_NEXT']
          }
          this.startTourWithTexts(customTexts);
        }
        // For other languages, use AWS translation
        else {
          from(Promise.all([
            this.globalTranslateService.translate(translations['TUTORIAL_FINISH'], selectedLang),
            this.globalTranslateService.translate(translations['TUTORIAL_PREV'], selectedLang),
            this.globalTranslateService.translate(translations['TUTORIAL_NEXT'], selectedLang)
          ])).subscribe(([done, prev, next]) => {
            const customTexts = {
              done: done,
              prev: prev,
              next: next
            }
            this.startTourWithTexts(customTexts);
          });
        }
      });
    }
    else if (closeTutorial === 'true') {
      sessionStorage.removeItem('closeTutorial');
    }
  }

  startTourWithTexts(customTexts: any) {
      if (!this.isMobileView) {
        this.joyrideService.startTour({
          steps: ["Step1", "Step2", "Step3", "Step4", "Step5"],
          showPrevButton: false,
          showCounter: false,
          customTexts,
        }).subscribe({
          next: (data) => {
            if (data.name === 'Step1') {
              this.step1.nativeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            if (data.name === 'Step2') {
              this.step2.nativeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            if (data.name === 'Step3') {
              this.step3.nativeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            if (data.name === 'Step4') {
              this.step4.nativeElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            this.applyAccessibilityFocus(data);
          },
          complete: () => {
            this.resetAccessibilityFocus();
          }
        });
      } else {
        this.joyrideService.startTour({
          steps: ["Step6", "Step7", "Step8", "Step4", "Step9"],
          showPrevButton: false,
          showCounter: false,
          customTexts,
        }).subscribe({
          next: (data) => {
            this.applyAccessibilityFocus(data);
          },
          complete: () => {
            this.resetAccessibilityFocus();
          },
        })
      }
  }

  dashboardTutorial() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
    if (this.isMobileView) {
      this.showTutorialInMobileView = true;

      //Service Call to validate
      this.processService.getIsFromNextFAQ().subscribe((result) => {
        if (result) {
          this.headerComponent.dropdownOpened = true;
        }
      });
    } else {
      const url = this.router.url;
      if(!url.includes('user-profile/benefit-dashboard')) {
      this.router.navigateByUrl("user-profile/benefit-dashboard");
      }
      this.showTutorialInMobileView = false;
      this.headerComponent.dropdownOpened = false;
    }
    this.validateUser();
    this.openTutorial();
  }

  toAppealsDashboard(){
    this.router.navigateByUrl('user-profile/my-appeals');
  }

  continuance(){
    this.appealsService.showMessage = false;
    this.appealsService.showMessageWithdrawal = false;
  }

  get userStatus(): boolean {
    const hohWithoutReconDate = this.isLoggedUserHoh && !this.isReconDate && !this.isCaseTerminated && !this.dcsOrSSIMultipleCase && !this.isCaseDenied;
    const KbSwitchWithoutHohOrReconDate = this.kbSwitch && !this.isLoggedUserHoh && !this.isReconDate && !this.isCaseTerminated && !this.dcsOrSSIMultipleCase && !this.isCaseDenied;
    const hohWithReconDate = this.isLoggedUserHoh && this.isReconDate && !this.dcsOrSSIMultipleCase;
    const status = hohWithoutReconDate || KbSwitchWithoutHohOrReconDate || hohWithReconDate;
    return this.afbLinkToggle && status;
  }

  get isLinkDisable(): boolean {
    this.userProfileService.isLinkDisable.next(this.afbLinkToggle && this.userStatus && (this.renewalDisable || this.disableRmc))
      return (this.afbLinkToggle && this.userStatus && (this.renewalDisable || this.disableRmc))
  }

  ngOnDestroy() {
    this.showQFRLink?.unsubscribe();
    this.showAppealsLink?.unsubscribe();
    this.showHealthPlanLink?.unsubscribe();
  }

  openIdverifyModal() {
    this.modalService.openRidpVerifyModal();
  }

  get showIdVerifyLink(): boolean {
    const ridpStatus = sessionStorage.getItem('ridpIdVerifyStatusCode');
    return  ridpStatus && ridpStatus !== 'null' && ridpStatus !== 'SS';
  }

  increaseWidth(){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return globalLang === 'de' || globalLang === 'tl' || globalLang === 'ja';
  }

  goToAppealsDashboard() {
    this.router.navigateByUrl('user-profile/appeals-dashboard');
  }

  get isMyAppealsActive(): boolean {
    if (this.medicalAppealsSwitch) {
      return this.myAppealsTitle || this.appealDashboardTitle;
    }
    return this.appealDashboardTitle;
  }
}